<template>
  <div>
    <el-dialog v-if="dialogFormVisible" v-el-drag-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :width="'800px'" class="indexList-dialog" :title="'导入信息文件'">
      <el-form v-loading="doing" :model="vo" :element-loading-text="elementLoadingText">
        <div class="el-table el-table--fit el-table--border" style="width:100%">
          <div class="el-table__body-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width:100%">
              <tbody>
                <tr>
                    <td class="tdcont tdw83" colspan="6">
                        <div class="row-col">
                            <el-upload
                            ref="upload"
                            class="upload-demo"
                            accept=".zip"
                            :multiple="false"
                            :file-list="fileList"
                            :on-change="handleUploadChange"
                            :on-remove="removeFile"
                            :auto-upload="false"
                            :with-credentials="true"
                            :show-file-list="true"
                            :disabled="false"
                            :limit="1"
                            >
                            <el-button slot="trigger" type="text">选择文件</el-button>
                            </el-upload>
                        </div>
                    </td>
                </tr>
                <tr>
                  <td class="el-table__cell tdlbl tdw17" colspan="1">注意事项</td>
                  <td class="el-table__cell tdcont tdw83" colspan="5">
                    <div style="line-height:25px">
                        <!-- <div class="light" @click="handleDownLoad">1、请先下载<span style="color:red;width:100%;">ZIP导入示例；</span><br /></div> -->
                        <div class="light" style="cursor:default">
                        1、导入文件应为zip文件；<br />
                        2、请点击【导入】按钮，按照提示上传；<br />
                        3、进行导入操作时，请确保您导入的文件并未处于使用状态。
                        </div>
                      <!-- <span>
                        <strong>上传文件内容示例：</strong>
                      </span><br>
                      <span>
                        <a title="点击下载" @click="fileDownload(`/templates/importEngagement.xls`)"><span style="color:red;width:100%;">点击下载Excel导入示例</span></a>
                      </span> -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button v-for="(btn,key) in busiformBtns" :key="key" :disabled="doing" :plain="btn.btnType===null || btn.btnType===''" :icon="'el-icon-'+btn.btnIcon" :type="btn.btnType!==null?btn.btnType:''" @click="btn.btnClick">{{ btn.btnName }}</el-button>
      </div>
    </el-dialog>
    <!-- <commom-msg /> -->
  </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {},
    props: {},
    data() {
        return {
            dialogFormVisible: false,
            salaryAttachName: '',
            fileList: [],
            doing: false,
            busiformBtns: [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: this.closeDialog,
                    btnPermission: '',
                    btnType: ''
                }, {
                    id: 'btn_save',
                    btnName: '导 入',
                    btnIcon: 'check',
                    btnClick: this.submitSalary,
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ],
            elementLoadingText: '',
            voData: null,
            title: '',
            formType: ''
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('importProfileDialog', this.importProfileDialog)
        // this.$options.components['commom-msg'] = this.$loadComponent('@/wapp/khgl/components/KhglCommomMsg')
    },
    beforeDestroy() {
        this.$bus.off('importProfileDialog', this.importProfileDialog)
    },
    mounted() {},
    methods: {
        down(url) {
            this.fileDownload(url)
        },
        importProfileDialog(id = '') {
            this.title = '导入头像'
            this.formId = id
            this.dialogFormVisible = true
            if (id) {
                this.doing = true
                this.checkUpFacePhotoStatus(id)
            }
        },
        handleUploadChange(filed, fileList) {
            if (filed.name.indexOf('.zip') === -1 && filed.name.indexOf('.ZIP') === -1) {
                this.$alert('上传文件格式错误', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                this.fileList = []
                this.salaryAttachName = ''
                return
            }
            this.fileList = [filed]
            this.salaryAttachName = filed.name
        },
        //删除文件
        removeFile(file, files) {
            this.fileList = []
        },
        submitSalary() {
            var _this = this
            this.formValidate(() => {
                if (!this.fileList.length) {
                    this.$alert('请选择导入文件。', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    })
                    return
                }
                this.doing = true
                const file = new FormData()
                file.append('file', this.fileList[0].raw)
                this.$http({
                    url: '/xsgl/studentBasicInfo/upFacePhoto',
                    method: 'PUT',
                    data: file
                }).then(res => {
                    if (res.code === 'success') {
                        // this.checkUpFacePhotoStatus(res.body.taskId)
                        this.$message.success('头像导入中')
                        _this.closeDialog()
                        this.$bus.emit('refreshListData')
                    } else {
                        this.$message.error(res.message)
                        this.doing = false
                    }
                })
            })
        },
        checkUpFacePhotoStatus(id) {
            const _this = this
            this.$http({
                url: '/xsgl/studentBasicInfo/checkUpFacePhotoStatus',
                method: 'GET',
                params: {
                    taskId: id
                }
            }).then(res => {
                if (res.code === 'success') {
                    // this.$message.success('正在导入。')
                    // _this.closeDialog()
                    if (res.body.status === 'success') {
                        this.$message.success('导入成功')
                        this.elementLoadingText = `头像导入中，已导入${res.body.importNum}个。`
                        _this.closeDialog()
                        _this.$bus.emit('refreshListData')
                    } else if (res.body.status === 'error') {
                        this.$message.success('导入失败')
                    } else if (res.body.status === 'running') {
                        this.elementLoadingText = `头像导入中，已导入${res.body.importNum}个。`
                        setTimeout(() => {
                            _this.checkUpFacePhotoStatus(id)
                        }, 1000)
                    }
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                // _this.doing = false
            })
        },
        handleDownLoad() {
            this.fileDownload('/templates/学生档案导入模版.xls')
        },
        closeDialog() {
            this.salaryAttachName = ''
            this.fileList = []
            this.doing = false
            this.dialogFormVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.upload-demo {
    display: flex;
    align-items: center;
    /deep/.el-upload-list__item:first-child {
        margin-top:0;
    }
 }
</style>
